import _ from 'underscore'
import qs from 'querystring'
import Api from '../lib/request'
import CONSTANT from '../constant/cookie'
import cookie from '../lib/cookie'

const emptyProductListData = {
  page: {
    pageNum: 0,
    total: 0,
  },
  list: [],
}
// 6 根据groupCode获得分组信息
const getGroupInfoForTemplate = data => new Promise((resolve, reject) => {
  let query = ''
  if (!_.isEmpty(data)) {
    query = `?${qs.stringify(data)}`
  }
  let url = `${CONSTANT.REQUEST_HOST}${query}`
  // url = 'https://yapi.sdyxmall.com/mock/71/temp/group/info'
  Api.get(url, {
    headers: {
      'X-Host': 'mall.act.product-topic-template.group-info',
      'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
      .then((res) => {
        if (res.status !== 0) {
          return reject(res.msg)
        }
        resolve(res.data)
      }, (e) => {
        reject(e)
      })
})
  // 5 根据groupCode查询商品列表(获取卡适用商品列表)
const getGroupProducts = data => new Promise((resolve, reject) => {
  let query = ''
  if (!_.isEmpty(data)) {
    query = `?${qs.stringify(data)}`
  }
  let url = `${CONSTANT.REQUEST_HOST}${query}`
  // url = 'https://yapi.sdyxmall.com/mock/71/temp/product/list'
  // url = 'http://yapi.miz.hk/mock/184/list'
  Api.get(url, {
    headers: {
      'X-Host': 'mall.act.product-template.product-list',
      'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
  .then((res) => {
    if (res.status === 6003) {
      return resolve(emptyProductListData)
    }
    if (res.status !== 0) {
      return reject(res.msg)
    }
    resolve(res.data)
  }, (e) => {
    reject(e)
  })
})
// 4 根据templateId查询商品列表
const getSchemeListById = data => new Promise((resolve, reject) => {
  let query = ''
  if (!_.isEmpty(data)) {
    query = `?${qs.stringify(data)}`
  }
  const url = `${CONSTANT.REQUEST_HOST}${query}`
  Api.get(url, {
    headers: {
      'X-Host': 'mall.act.product-topic-template.info',
      'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
  .then((res) => {
    if (res.status === 6003) {
      return resolve(emptyProductListData)
    }
    if (res.status !== 0) {
      return reject(res.msg)
    }
    resolve(res.data)
  }, (e) => {
    reject(e)
  })
})
/* yeoman-template-point-1 */
export default {
  getGroupInfoForTemplate,
  getGroupProducts,
  getSchemeListById,
/* yeoman-template-point-2 */
}
